import VideoErrorInterface from '@videos/errors/video-error.interface';
import { VideoError } from '@videos/errors/video-error';

export default class VideoPreviewServiceUnavailableError extends VideoError implements VideoErrorInterface {
    readonly code = 'service-unavailable';
}
